class RadioToggle {
  /**
   * Create new form toggle
   * @param {HTMLDivElement} container Container with radios
   */
  constructor (container) {
    this.container = container
    this.radios = container.querySelectorAll('input[type="radio"]')
    this.targets = []

    this.radios.forEach(radio => {
      const target = radio.dataset.target

      if (target) {
        this.targets.push(document.querySelector(`#${target}`))
      }
    })
  }

  /**
   * Initialize radio toggle
   */
  init () {
    this.container.addEventListener('change', event => {
      if (event.target.checked) {
        this.setState(event.target.dataset.target)
      } else {
        this.setState()
      }
    })

    this.radios.forEach(radio => {
      if (radio.checked) {
        this.setState(radio.dataset.target)
      }
    })
  }

  /**
   * Set target states
   * @param {String} id Target ID
   */
  setState (id) {
    this.targets.forEach(target => {
      if (target.id === id) {
        target.hidden = false
      } else {
        target.hidden = true
      }
    })
  }
}

const elements = document.querySelectorAll('.js-radio-toggle')
elements.forEach(element => new RadioToggle(element).init())
